/**
 * Anomaly explanation client. POSTs to /v1/explain/metric, returns the
 * narrative + cache flag.
 */
import { api } from './api';

export interface ExplainEvidence {
  label: string;
  value: string | number;
  delta?: string | number;
  meta?: Record<string, unknown>;
}

export interface ExplainRequest {
  metric: string;
  current: number | string;
  prior?: number | string;
  period: string;
  unit?: string;
  evidence?: ExplainEvidence[];
  notes?: string;
}

export interface ExplainResponse {
  explanation: string;
  confidence: 'low' | 'med' | 'high';
  cached: boolean;
  tokensUsed?: number;
}

export function explainMetric(input: ExplainRequest): Promise<ExplainResponse> {
  return api<ExplainResponse>('/v1/explain/metric', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

